"use client"
import Script from "next/script"
import { getConsent } from "@/lib/consent"
import { siteConfig } from "@/lib/config"
import { useState, useEffect } from "react"

export function Analytics() {
  const [allowAnalytics, setAllowAnalytics] = useState(false);
  const id = siteConfig.analyticsId;

  useEffect(() => {
    const consent = getConsent();
    setAllowAnalytics(!!consent?.analytics);

    const handleConsentUpdate = () => {
      const updatedConsent = getConsent();
      setAllowAnalytics(!!updatedConsent?.analytics);
    };

    window.addEventListener("consentUpdated", handleConsentUpdate);
    return () => window.removeEventListener("consentUpdated", handleConsentUpdate);
  }, []);

  if (!allowAnalytics || !id) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${id}`}
        strategy="lazyOnload"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${id}');
        `}
      </Script>
    </>
  );
}
